import {Model} from "ords/dist/model/model";

export class groups extends Model {

}

export const groupsModelConfig = {
    name: 'groups',
    model: groups,
    relations : [
        {name: 'projects', model_name: 'projects', type: 'hasMany'},
        {name: 'rubric_surveys', model_name: 'rubricSurvey', type: 'hasMany'},
    ]
}
